import React, { memo, useCallback, useState } from "react";
import {
  checkValue,
  convertNumToFa,
  getHoursMinutesTime,
  getPersianDateObj,
  getSessionStatus,
  hasOwnNestedProperty,
} from "../../constant/helper";
import SmallButton from "../../components/SmallButton";
import { ReactComponent as TransactionPen } from "../../images/transactions/transaction-pen.svg";
import {
  getTransactionDetailService,
  sendInvoicesRequest,
} from "./transactions.api";
import { Col, Collapse, message, Row, Skeleton, Typography } from "antd";

const { Paragraph } = Typography;
const { Panel } = Collapse;

const TransactionItem = (props) => {
  const { item } = props;

  const toPersian = getPersianDateObj(item.createdDateMilli);

  const [activeKey, setActiveKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [transactionDetail, setTransactionDetail] = useState(false);

  const handleExpandItem = (mixedIds) => {
    let relatedId = "";

    if (mixedIds && mixedIds.length) {
      const mixedId = mixedIds.split("_", 2);
      relatedId =
        mixedId.length > 1 && mixedId[1].length > 0
          ? mixedId[1]
          : "" /* mixedId[0] */;

      setLoading(true);
      setActiveKey(mixedIds);

      if (relatedId && relatedId.length > 0) {
        getTransactionDetailService(relatedId)
          .then((res) => {
            if (res.data) {
              setTransactionDetail(res.data);
            }
          })
          .catch(() => {
            message.error("خطایی در دریافت اطلاعات");
            setTransactionDetail(null);
            closeExpandItem();
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        message.info("این تراکنش دارای جزئیات بیشتر نیست");
        setLoading(false);
        closeExpandItem();
      }
    } else {
      closeExpandItem();
    }
  };

  const closeExpandItem = () => {
    setActiveKey("");
  };

  const sendInvoicesRequestHandler = () => {
    setInvoiceLoading(true);

    sendInvoicesRequest(item.id)
      .then((resp) => {
        message.success("درخواست با موفقیت ثبت شد");
      })
      .catch((error) => {
        hasOwnNestedProperty(error, "response.data.message") &&
          message.error(error.response.data.message);
      })
      .finally(() => {
        setInvoiceLoading(false);
      });
  };

  const fetchLawyerName = useCallback(() => {
    let lawyerName = "نامشخص";
    if (checkValue(transactionDetail.lawyer)) {
      if (checkValue(transactionDetail.lawyer.extraInfo)) {
        if (checkValue(transactionDetail.lawyer.extraInfo.firstName)) {
          lawyerName =
            transactionDetail.lawyer.extraInfo.firstName ||
            "" + transactionDetail.lawyer.extraInfo.lastName ||
            "";
        } else {
          lawyerName = transactionDetail.lawyer.username;
        }
      }
    }

    return lawyerName;
  }, [transactionDetail]);

  const IdontKnowWhatTheHellIsThis = (value) => {
    return value === "deposit by client" ? "افزایش اعتبار" : value;
  };

  return (
    <Collapse
      accordion={true}
      ghost
      activeKey={activeKey}
      bordered={false}
      expandIcon={false}
      onChange={handleExpandItem}
    >
      <Panel
        key={`${item.id}_${item.relatedId || ""}`}
        showArrow={false}
        className=""
        header={
          <Row className="transaction">
            <Col flex="auto" className="">
              <Row align="middle">
                <Col className="icon pl-20">
                  <TransactionPen />
                </Col>
                <Col className="info" flex="auto">
                  <div className="description">
                    <div className="title">نوع:</div>
                    <div className="text">
                      {checkValue(item.description)
                        ? IdontKnowWhatTheHellIsThis(item.description)
                        : Number(item.amount) > 0
                        ? "افزایش اعتبار"
                        : ""}
                    </div>
                  </div>
                  <div className="amount">
                    <div className="title">مبلغ:</div>
                    <div className="text">
                      {convertNumToFa(item.amount.toLocaleString("fa"))}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col className="date-time">
              <div className="date">
                {toPersian
                  ? `${toPersian.year}/${toPersian.month}/${toPersian.day}`
                  : ""}
              </div>
              <div className="time">
                {getHoursMinutesTime(item.createdDateMilli)}
              </div>
            </Col>
          </Row>
        }
      >
        <div className="expanded-log">
          <Skeleton
            active={true}
            loading={loading}
            avatar={false}
            paragraph={{ rows: 2 }}
          >
            {transactionDetail ? (
              <>
                <Row>
                  <Col span={12}>
                    <Paragraph>
                      <small>
                        کد پیگیری:{" "}
                        <b>
                          {(transactionDetail.hasOwnProperty("trackId") &&
                            transactionDetail.trackId) ||
                            "نامشخص"}
                        </b>
                      </small>
                    </Paragraph>
                  </Col>
                  <Col span={12}>
                    <Paragraph>
                      <small>
                        زمان بررسی مدارک:{" "}
                        <b>
                          {(transactionDetail.hasOwnProperty("battery") &&
                            transactionDetail.battery
                              .consumedDocumentPagesTimeInSeconds / 60) ||
                            0}{" "}
                          دقیقه
                        </b>
                      </small>
                    </Paragraph>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Paragraph>
                      <small>
                        نام وکیل: <b>{fetchLawyerName()}</b>
                      </small>
                    </Paragraph>
                  </Col>
                  <Col span={12}>
                    <Paragraph>
                      <small>
                        زمان مشاوره نوشتاری:{" "}
                        <b>
                          {(transactionDetail.hasOwnProperty("battery") &&
                            transactionDetail.battery
                              .consumedCharactersTimeInSeconds) ||
                            0}{" "}
                          دقیقه
                        </b>
                      </small>
                    </Paragraph>
                  </Col>
                </Row>
                <Row>
                  <Col span={12}>
                    <Paragraph>
                      <small>
                        وضعیت مشاوره:{" "}
                        <b>
                          {(transactionDetail.hasOwnProperty("sessionStatus") &&
                            getSessionStatus(
                              transactionDetail.sessionStatus
                            )) ||
                            "نامشخص"}
                        </b>
                      </small>
                    </Paragraph>
                  </Col>
                  <Col span={12}>
                    <Paragraph>
                      <small>
                        زمان مشاوره صوتی:{" "}
                        <b>
                          {(transactionDetail.hasOwnProperty("battery") &&
                            transactionDetail.battery.voiceSpentTime) ||
                            0}{" "}
                          دقیقه
                        </b>
                      </small>
                    </Paragraph>
                  </Col>
                </Row>

                <div className="submit-btn">
                  <SmallButton
                    onClick={sendInvoicesRequestHandler}
                    loading={invoiceLoading}
                  >
                    دریافت فاکتور رسمی
                  </SmallButton>
                </div>
              </>
            ) : (
              ""
            )}
          </Skeleton>
        </div>
      </Panel>
    </Collapse>
  );
};

export default memo(TransactionItem);
